let portfolioItems=[{portfolioImageUrl:'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80',
gitHubUrl:"https://github.com/belisky/bel-clothing",
liveSiteUrl:"https://b-clothing-live.herokuapp.com/"},
{
    portfolioImageUrl:'https://images.unsplash.com/photo-1529651737248-dad5e287768e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=465&q=80',
    gitHubUrl:"https://github.com/belisky/ReminderApp",
    liveSiteUrl:"https://bel-reminder.netlify.app/"
},{
    portfolioImageUrl:'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80',
    gitHubUrl:"https://github.com/belisky/GoogleDriveClone",
    liveSiteUrl:"https://bel-drive-clone.herokuapp.com/"
},{
    portfolioImageUrl:'https://images.unsplash.com/photo-1636751364472-12bfad09b451?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    gitHubUrl:'https://github.com/belisky/WhatsAppClone',
    liveSiteUrl:'https://bel-chat-app.herokuapp.com/'
}
]

export default portfolioItems